export default __webpack_public_path__ + "static/partner7-6027118703c9248913def0353afed5c6.png";